import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-two-arrow-left",
  "use": "icon-si-glyph-two-arrow-left-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-two-arrow-left\" id=\"icon-si-glyph-two-arrow-left\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1134</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 3.000000)\" fill=\"#434343\">\n            <path d=\"M4.146,5.027 L7.89,0.032 L3.95,0.032 L0.007,5.027 L4.049,9.991 L7.967,9.991 L7.977,9.98 L4.146,5.027 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M11.929,5.027 L15.88,0.032 L11.941,0.032 L7.976,5.027 L12.04,9.991 L15.958,9.991 L15.968,9.98 L11.929,5.027 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-two-arrow-left.svg
// module id = wqXF
// module chunks = 62